import { gql } from '@apollo/client';

export const EXPORT_MA_OPPORTUNITIES_ENDPOINT = 'm-a/export-opportunities';

export const MA_OPPORTUNITIES_QUERY = gql`
  query maOpportunities($filters: MaFilters, $pagination: PaginationInput) {
    maOpportunities(filters: $filters, pagination: $pagination) {
      totalCount
      opportunities {
        id
        group
        country {
          id
          displayName
          isoCode
        }
        sellerCompanyName
        sellerCompany {
          name
        }
        sellerStake
        sellerMotivation
        resourceTheme
        operatedStake
        comment
        officiallyOnMarket
        dateOfEntry
        npv
        pricePerFlowingBarrel
        remainingCapex
        remainingLiquidReserves
        remainingGasReserves
        remainingReserves
        estimatedRecentProduction

        assetName
        asset {
          currentEmissionsIntensity
          displayName
          hydrocarbonType
          legacyId
          licenseExpirationDate
          pricePerBarrel
          remainingEmissionsIntensity

          basin {
            name
          }
          shoreStatus {
            name
          }
          developmentStatus {
            name
          }
          currentParticipations {
            company {
              name
            }
            percentStake
          }
        }
      }
    }
  }
`;
